import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ファネル分析セクションのレイアウトルート。一覧と詳細の子ルートOutlet
 * @graph-connects none
 */
export const Route = createFileRoute('/funnels')({
  component: FunnelsLayout,
});

/** @graph-connects none */
function FunnelsLayout() {
  return <Outlet />;
}
